import { value } from "devexpress-dashboard/model/index.metadata";

const status = [
    { key: "A", value: "Allow All Receipts Shipments" },
    { key: "N", value: "Receipts/Shipments Not Allowed" },
    { key: "R", value: "Allow Receipts Only" },
    { key: "S", value: "Allow Shipments Only" }
];
const LotStatus =[{ key: 'A', value: "Active" }, { key: 'I', value: "Inactive" }, { key: 'D', value: "Delete" }]
const TransactionStatuses = [{ key: 'O', value: 'Open' }, { key: 'H', value: 'Hold' }, { key: 'R', value: 'Ready To Commit Later' }];
const locationTypes = [
    { key: "D", value: "Dock Door" },
    { key: "F", value: "Forward Pick" },
    { key: "L", value: "Staging Location" },
    { key: "P", value: "Production Location" },
    { key: "S", value: "Storage Location" },
    { key: "Y", value: "Yard" }
];
const optionsYesNo = [{ key: "Y", value: "Yes" }, { key: "N", value: "No" }];
const TaskType = [
    { key: 1, value: "Send E-mail" },
    { key: 2, value: "Send Fax" },
    { key: 3, value: "Write To Windows Event Log" },
    { key: 4, value: "Write To Alert Log" },
    { key: 5, value: "Run ABECAS Insight Report/Program" },
    { key: 6, value: "Run Crystal Report" },
    { key: 7, value: "Run Program" },
    { key: 8, value: "Execute SQL Script" },
    { key: 9, value: "Import Data" },
    { key: 10, value: "Generate Export Data" },
    { key: 11, value: "Transfer Export Data" },
    { key: 12, value: "Process TaskAgent Job" },
    { key: 13, value: "Scheduale TaskAgent Job" },
    { key: 14, value: "Send FTP" },
    { key: 15, value: "Receive FTP" },
    { key: 16, value: "Receive POP3 E-mail" },
    { key: 17, value: "Maintenance Cleanup" },
]
const TaskState = [
    { key: "E", value: "Expired", icon: "clock" },
    { key: "F", value: "Failed", icon: "close" },
    { key: "P", value: "Processing", icon: "refresh" },
    { key: "S", value: "Successfully Processed", icon: "check" },
    { key: "U", value: "Unknown", icon: "help" },
    { key: "W", value: "Waiting to be Processed", icon: "info" },
];
const CommissionBases = [{ key: 'A', value: "Percent" }, { key: 'U', value: "Per Unit" }, { key: 'F', value: "Flat" }
    , { key: 'L', value: "Last Cost at Time Of OM Entry" }, { key: 'V', value: "Average Cost at Time of OM Entry" }, { key: 'S', value: "Standard Cost at Time of OM Entry" }, { key: 'I', value: "Calculate Based on Item" }
]
const TradeDisc = [
    { key: 'Y', value: "Yes, Apply Custom Discount" },
    { key: 'N', value: "No" }
];

const CostBasisMethodFlag = [
    { key: 'S', value: "Standard Cost" },
    { key: 'A', value: "Average Cost" },
    { key: 'L', value: "Last Cost" }
];

const RoundingMethod = [
    { key: 'A', value: "Round Up To Factor" },
    { key: 'B', value: "Round Down To Factor" },
    { key: 'C', value: "Round To Nearest Factor" },
    { key: 'N', value: "Round Up To #" },
    { key: 'E', value: "Round Down To #" },
    { key: 'F', value: "Round To Nearest #" }
];

const PriceSource = [
    { key: 'S', value: "Single Price" },
    { key: 'P', value: "Price Code" },
    { key: 'I', value: "Item Master" }
];

const PriceMethod = [
    { key: 'D', value: "Direct Price" },
    { key: 'B', value: "Basis Price" },
    { key: 'S', value: "Standard Cost" },
    { key: 'A', value: "Average Cost" },
    { key: 'L', value: "Last Cost" }
];

const CalcMethod = [
    { key: 'M', value: "% Markup" },
    { key: 'G', value: "Gross Margin" },
    { key: 'F', value: "Fixed Markup" }
];
    const PriceLevelColumns = [
        {key:"A", dataType: "string", dataField: "PriceLevelA", caption: "Price Level - A" },
        {key:"B", dataType: "string", dataField: "PriceLevelB", caption: "Price Level - B" },
        {key:"C", dataType: "string", dataField: "PriceLevelC", caption: "Price Level - C" },
        {key:"D", dataType: "string", dataField: "PriceLevelD", caption: "Price Level - D" },
        {key:"E", dataType: "string", dataField: "PriceLevelE", caption: "Price Level - E" },
        {key:"F", dataType: "string", dataField: "PriceLevelF", caption: "Price Level - F" },
        {key:"G", dataType: "string", dataField: "PriceLevelG", caption: "Price Level - G" },
        {key:"H", dataType: "string", dataField: "PriceLevelH", caption: "Price Level - H" },
        {key:"I", dataType: "string", dataField: "PriceLevelI", caption: "Price Level - I" },
        {key:"J", dataType: "string", dataField: "PriceLevelJ", caption: "Price Level - J" },
        {key:"K", dataType: "string", dataField: "PriceLevelK", caption: "Price Level - K" },
        {key:"L", dataType: "string", dataField: "PriceLevelL", caption: "Price Level - L" },
        {key:"M", dataType: "string", dataField: "PriceLevelM", caption: "Price Level - M" },
        {key:"N", dataType: "string", dataField: "PriceLevelN", caption: "Price Level - N" },
        {key:"O", dataType: "string", dataField: "PriceLevelO", caption: "Price Level - O" },
        {key:"P", dataType: "string", dataField: "PriceLevelP", caption: "Price Level - P" },
        {key:"Q", dataType: "string", dataField: "PriceLevelQ", caption: "Price Level - Q" },
        {key:"R", dataType: "string", dataField: "PriceLevelR", caption: "Price Level - R" },
        {key:"S", dataType: "string", dataField: "PriceLevelS", caption: "Price Level - S" },
        {key:"T", dataType: "string", dataField: "PriceLevelT", caption: "Price Level - T" },
        {key:"U", dataType: "string", dataField: "PriceLevelU", caption: "Price Level - U" },
        {key:"V", dataType: "string", dataField: "PriceLevelV", caption: "Price Level - V" },
        {key:"W", dataType: "string", dataField: "PriceLevelW", caption: "Price Level - W" },
        {key:"X", dataType: "string", dataField: "PriceLevelX", caption: "Price Level - X" },
        {key:"Y", dataType: "string", dataField: "PriceLevelY", caption: "Price Level - Y" },
        {key:"Z", dataType: "string", dataField: "PriceLevelZ", caption: "Price Level - Z" }
    ];
   const InventoryQuantitySource= [{ key: 'I', value: "Item" }, { key: 'L', value: "Lot" }, { key: 'S', value: "Sublot" }];
   const WeightBasisFlag= [{ key: 'I', value: "Item" }, { key: 'L', value: "Lot" }, { key: 'S', value: "Sublot" }, { key: 'U', value: "Unit" }];
   const ReceiptUomDefault= [{ key: 'I', value: "Inventory Unit" }, { key: 'P', value: "Pieces" }, { key: 'P', value: "Packages (eg. Pallets)" }, { key: 'H', value: "Shipment (eg. Container)" }];
   const RfReceiptValidation= [{ key: 'Y', value: "EDI import to insert Serial # records for valdation by RF program" }, { key: 'N', value: "EDI import to gonre Serial # records or Serial #s do not exist" }];
   const RfShipmentValidation= [{ key: 'Y', value: "EDI import to insert Serial # records for valdation by RF program" }, { key: 'N', value: "EDI import to gonre Serial # records or Serial #s do not exist" }];
   const ItemSourceFlag=[{ key: 'M', value: 'Manufactured' }, { key: 'P', value: 'Purchased' }, { key: 'O', value: 'Manufactured & Ordered' }, { key: 'R', value: 'Purchased & Ordered' }, { key: 'B', value: 'Brokered' }, { key: 'D', value: 'Drop-Ship' }];
   const ItemTypeFlag=[{ key: 'I', value: 'Item' }, { key: 'L', value: 'Item/Lot' }, { key: 'S', value: 'Item/Lot/Sublot' }, { key: 'U', value: 'Item/Lot/Sublot/Unit' }];
   const TaxStatus= [{ key: 'Y', value: "Yes" }, { key: 'N', value: "No" }, { key: 'A', value: "Always Taxable" }];
   const ReorderMethodFlag= [{ key: 'N', value: "Not Applicable" }, { key: 'M', value: "Based on Minimum-Maximum Quantity" }, { key: 'P', value: "Based on Minimum with Preset Order Quantity" }];
   const TaskQueueType = [{ key: 1, value: 'All' },{ key: 2, value: 'Task Queue Live' }, { key: 3, value: 'Task Queue History' }]
   const CreditReview = [
    { key: 'N', value: "Not Required" },
    { key: 'R', value: "Review Required" },
    { key: 'A', value: "Review Approved" }
];
const ChargeHoldType = [{ key: "A", value: "Not Applicabale" }];
const OrderSigned = [{ key: "Y", value: "Yes" },{ key: "N", value: "No" },{ key: "H", value: "No - Order Must be Signed to Print Pcking Slip or Change Stage to 'Picked' ord 'Completed' " }];
const CommissionType = [{ key: "N", value: "No Commissions" },{ key: "H", value: "By Transaction Header Only" }, { key: "D", value: "By Transaction Detail Only" },{ key: "B", value: "By Both Transaction Header & Detail" }
    ,{ key: "A", value: "Calculate When cash is received" }];

 const TransactionTypes = 
    [{ key:"R", value:"Receipt" },
    { key:"S", value:"Shipment" },
    { key:"A", value:"Adjustment" }]
// IDDISCOUNTHEADER coded columns, shown read-only on the OM Cumulative Trade Discounts popup
// (Delphi OMD0023). Codes and captions come from the flag lists on uOMM0023.dfm.
const DiscountBasisMethods = [
    { key: "T", value: "Transaction Total Only" },
    { key: "S", value: "Cumulative Using Same Discount Code On All Transactions" },
    { key: "A", value: "Cumulative On All Transactions With A Discount Code" }
];
const DiscountApplyOn = [{ key: "A", value: "All" }, { key: "N", value: "None" }];
const DiscountBasisInclusion = [
    { key: "I", value: "Include In Discount Basis" },
    { key: "E", value: "Exclude From Discount Basis" }
];
// OMTRANSACTIONHEADER.STATUS. Wider than TransactionStatuses above, which is the subset a user may
// pick on data entry; these are every value a transaction can be listed with.
const OmTransactionStatuses = [
    { key: "O", value: "Open" },
    { key: "H", value: "Hold" },
    { key: "L", value: "Ready To Commit Later" },
    { key: "N", value: "Ready To Commit Now" },
    { key: "Z", value: "Committed" }
];
// OMTRANSACTIONHEADER.STAGE. Codes are the ones in OrderStages (enum/Enum.js); the captions here are
// the plain stage names, without the "- Effects Available" suffix the stage-change operation screens
// add, which describes what a change does rather than what a listed transaction is.
const OmTransactionStages = [
    { key: "L", value: "Canceled" },
    { key: "Q", value: "Quote" },
    { key: "P", value: "Plan" },
    { key: "F", value: "Future" },
    { key: "N", value: "Pending" },
    { key: "A", value: "Assigned" },
    { key: "S", value: "Picked/Staged" },
    { key: "C", value: "Shipped/Completed" }
];

// AI Assistant -> Usage Metrics. Keys are the codes the usage API returns (the TurnResultKind,
// LlmErrorKind, ResolutionSource and UsageTopics names in Argos.Core.Data.DTO.AI).
const AIUsageResultKinds = [
    { key: "Delivered", value: "Delivered" },
    { key: "AnsweredWithoutData", value: "Answered without data" },
    { key: "UnsupportedRequest", value: "Unsupported report" },
    { key: "NoRecordsFound", value: "No records found" },
    { key: "NeedsInput", value: "Needs input" },
    { key: "FoundButFieldEmpty", value: "Found, field empty" },
    { key: "FieldNotAvailable", value: "Field not on report" },
    { key: "Error", value: "Tool error" },
    { key: "LlmError", value: "LLM error" },
    { key: "NoAnswer", value: "No reply produced" },
    { key: "NoDataRequest", value: "Not a data request" },
    { key: "FileSearch", value: "File search" },
    { key: "Unknown", value: "Unrecognised" }
];
// The dashboard's bars: every result kind, plus UserDisliked - a failure only because the user disliked
// it, which is a bar but not a kind.
const AIUsageBuckets = [...AIUsageResultKinds, { key: "UserDisliked", value: "Disliked by user" }];
const AIUsageLlmErrorKinds = [
    { key: "ContextLengthExceeded", value: "Context too long" },
    { key: "QuotaExhausted", value: "Out of credit" },
    { key: "RateLimited", value: "Rate limited" },
    { key: "Timeout", value: "Timeout" },
    { key: "AuthFailure", value: "Auth failure" },
    { key: "ProviderUnavailable", value: "Provider unavailable" },
    { key: "Other", value: "Other" }
];
const AIUsageFeedbackActions = [{ key: "Like", value: "Like" }, { key: "Dislike", value: "Dislike" }];
const AIUsageVerdicts = [
    { key: "Success", value: "Delivered" },
    { key: "Failure", value: "Failed" },
    { key: "Excluded", value: "Excluded" }
];
// Signals that sit beside the result rather than being one - each a drill-down of its own.
const AIUsageFlags = [
    { key: "IdentifierFriction", value: "Identifier friction" },
    { key: "CoverageViolation", value: "Coverage violation" },
    { key: "Repaired", value: "Repaired by the composer" },
    { key: "DeliveredButDisliked", value: "Delivered but disliked" },
    { key: "NoApiCall", value: "No API call" },
    { key: "AnsweredWithoutData", value: "Answered without data" },
    { key: "Unrecognised", value: "Unrecognised" },
    { key: "Rated", value: "Rated by the user" }
];
const AIUsageResolutionSources = [{ key: "Classifier", value: "Rules" }, { key: "Feedback", value: "User feedback" }];
const AIUsageTopics = [
    { key: "LotRecap", value: "Lot recap" },
    { key: "Inventory", value: "Inventory" },
    { key: "ShipmentStatus", value: "Shipment status" },
    { key: "BillOfLading", value: "Bill of lading" },
    { key: "Invoicing", value: "Invoicing" },
    { key: "TransactionHistory", value: "Transaction history" },
    { key: "Unclassified", value: "Unclassified" }
];

export { status, locationTypes, optionsYesNo, TaskType, TaskState,TaskQueueType,LotStatus,
    CommissionBases,
    TradeDisc,
    CostBasisMethodFlag,
    RoundingMethod,
    PriceSource,
    PriceMethod,
    CalcMethod,
    InventoryQuantitySource,
    WeightBasisFlag,
    ReceiptUomDefault,
    RfReceiptValidation,
    RfShipmentValidation,
    ItemSourceFlag,
    ItemTypeFlag,
    TaxStatus,
    ReorderMethodFlag,
    CreditReview,
    ChargeHoldType,
    OrderSigned,
    CommissionType,
    TransactionStatuses,
    PriceLevelColumns,
    TransactionTypes,
    DiscountBasisMethods,
    DiscountApplyOn,
    DiscountBasisInclusion,
    OmTransactionStatuses,
    OmTransactionStages,
    AIUsageResultKinds,
    AIUsageBuckets,
    AIUsageLlmErrorKinds,
    AIUsageFeedbackActions,
    AIUsageVerdicts,
    AIUsageFlags,
    AIUsageResolutionSources,
    AIUsageTopics
};